import './ComparisonChartStyles.css'
import React from 'react';
import { useEffect, useState } from 'react';

import background from '../../Media/ComparisonChart/Background01.svg';

import lowImpact from '../../Media/ComparisonChart/LowImpact.svg';
import mediumImpact from '../../Media/ComparisonChart/MediumImpact.svg';
import highImpact from '../../Media/ComparisonChart/HighImpact.svg';

import tennesseeState from '../../Media/ComparisonChart/Tennessee-state01.svg';
import texasState from '../../Media/ComparisonChart/Texas-state01.svg';
import californiaState from '../../Media/ComparisonChart/California-state01.svg';


import {app} from '../../firebase/firebaseConfig';
import {getDatabase, ref, onValue} from "firebase/database";


const db = getDatabase(app);
const checkCurrentValue = ref(db, 'jackson2/realtimeData/lastHour');

const ComparisonChart = () => {

    const [currentMOER, setCurrentMOER] = useState([0,0,0])
    const [prevMOER, setPrevMOER] = useState()
    const [caliDisplay, setCaliDisplay] = useState('hidden')
    const [texDisplay, setTexDisplay] = useState('hidden')
    const [tennDisplay, setTennDisplay] = useState('hidden')



    useEffect(()=> {
        onValue(checkCurrentValue, (snapshot) => {
            const data = snapshot.val();
            const MOERdata = data.lastValue.moer
            
            if(JSON.stringify(MOERdata) !== JSON.stringify(prevMOER)){
                let MOERArray = [
                    {location: 'TVA',
                    value: parseFloat(MOERdata.TVA),
                    image: tennesseeState},
                    {location: 'CAISO_NORTH',
                    value: parseFloat(MOERdata.CAISO_NORTH),
                    image: californiaState},
                    {location: 'ISONE_CT',
                    value: parseFloat(MOERdata.ISONE_CT),
                    image: texasState}
                ]

                MOERArray.sort((a,b) => {
                    return a.value - b.value
                })
                
                setCurrentMOER(MOERArray);
                setPrevMOER(MOERdata)
                
            }

        })
    },[currentMOER, prevMOER])
    

    return(
        <div id='chart-container'>
            <svg viewBox={`0 0 100 100`} xmlns="http://www.w3.org/2000/svg">
                <image href={background} width="100" height="100"> </image>

                <image href={currentMOER[0].image} width="100" height="100" x='-26'> </image>
                <image href={currentMOER[1].image} width="100" height="100"> </image>
                <image href={currentMOER[2].image} width="100" height="100" x = '27.5'> </image>


                <image href={lowImpact} width="100" height="100" className={caliDisplay} ></image>
                <image href={mediumImpact} width="100" height="100" className={texDisplay}> </image>
                <image href={highImpact} width="100" height="100" className={tennDisplay}> </image>
                
                
                <text x='87' y='41' fill='black' className={`carbon-text ${tennDisplay}`} textAnchor='left'>
                    {
                        currentMOER[2].value
                    } lbs</text>

                <text x='87' y='43' fill='black' className={`carbon-text ${tennDisplay}`} textAnchor='left'>CO2/ MWH</text>

                <text x='87' y='57' fill='black' className={`carbon-text ${texDisplay}`} textAnchor='left'>
                    {
                        currentMOER[1].value
                    } lbs</text>

                <text x='87' y='59' fill='black' className={`carbon-text ${texDisplay}`} textAnchor='left'>CO2/ MWH</text>

                <text x='87' y='73.5' fill='black' className={`carbon-text ${caliDisplay}`} textAnchor='left'>
                    {
                        currentMOER[0].value
                    } lbs</text>

                <text x='87' y='75.5' fill='black' className={`carbon-text ${caliDisplay}`} textAnchor='left'>CO2/ MWH</text>

                

                <rect width='26.5' height='100' x='6' y='0' fill='red' className='cali-trigger' 
                onMouseEnter={() => setCaliDisplay('show')} 
                onMouseLeave = {() => setCaliDisplay('hidden')}></rect>
                
                <rect width='26.5' height='100' x='32.5' y='0' fill='green' className='cali-trigger' 
                onMouseEnter={() => {
                    setTexDisplay('show')
                    setCaliDisplay('show')}
                }
                onMouseLeave = {() => {
                    setTexDisplay('hidden')
                    setCaliDisplay('hidden')
                    }}></rect>

                <rect width='26.5' height='100' x='59' y='0' fill='blue' className='cali-trigger' 
                onMouseEnter={() => {
                    setTexDisplay('show')
                    setCaliDisplay('show')
                    setTennDisplay('show')}
                }
                onMouseLeave = {() => {
                    setTexDisplay('hidden')
                    setCaliDisplay('hidden')
                    setTennDisplay('hidden')
                    }}></rect>
               

            </svg>
            
        </div>
    )
}

export default ComparisonChart